import { useCallback } from 'react';

import { GameFrame } from '@/features/game-client/game-frame';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import { Platform } from '@/features/game-context/types';
import { useEvolutionEventHandlers } from '@/features/game-window-integration/use-evolution-event-handlers';
import { resolveEvolutionScriptDomain } from '@/features/providers/evolution/resolve-evolution-script-domain';
import { FGPEvolutionLaunchData } from '@/features/providers/evolution/types';
import { GameDataProp } from '@/features/providers/types';
import { useAppSelector } from '@/store/hooks';
import { LoadScript } from '@/utils/load-script';

export const Evolution: React.FC<GameDataProp> = ({ data }: GameDataProp) => {
  const launchData = data as FGPEvolutionLaunchData;
  const { host, url } = launchData.launchDetails;
  const { gameName, platform } = useAppSelector(gameContextSelector);

  const domain = resolveEvolutionScriptDomain(
    launchData.launchDetails,
    launchData.source,
  );

  const scriptUrl = domain ? `https://${domain}/mobile/js/iframe.js` : undefined;

  const initGame = useCallback(() => {
    if (window.EvolutionGaming) {
      window.EvolutionGaming.init({
        allowFullscreen: true,
        iframeId: 'game-client',
      });
    }
  }, []);

  useEvolutionEventHandlers();

  return (
    <>
      <GameFrame title={gameName} url={url ?? host} allowFullscreen />
      {platform !== Platform.Web && scriptUrl && (
        <LoadScript url={scriptUrl} onLoad={initGame} />
      )}
    </>
  );
};
